import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IProFormaMapping } from '../../views/ProFormaUpload/types';

export interface IExcelMappingCellSchema {
    sheet: string;
    cell: string;
    name: string;
}

export interface IMappingData {
    dealTypeId: number;
    unleveredIrr?: IExcelMappingCellSchema | null;
    leveredIrr?: IExcelMappingCellSchema | null;
    limitedPartnerIrr?: IExcelMappingCellSchema | null;
    generalPartnerIrr?: IExcelMappingCellSchema | null;
    untrendedYieldOnCost?: IExcelMappingCellSchema | null;
    trendedYieldOnCost?: IExcelMappingCellSchema | null;
    effectiveGrossRevenue?: IExcelMappingCellSchema | null;
    totalOperatingExpenses?: IExcelMappingCellSchema | null;
    netOperatingIncome?: IExcelMappingCellSchema | null;
    capitalExpenditures?: IExcelMappingCellSchema | null;
    cashFlowFromOps?: IExcelMappingCellSchema | null;
    valuation?: IExcelMappingCellSchema | null;
    acquisitionCosts?: IExcelMappingCellSchema | null;
    hardCosts?: IExcelMappingCellSchema | null;
    softCosts?: IExcelMappingCellSchema | null;
    financingCosts?: IExcelMappingCellSchema | null;
    totalUses?: IExcelMappingCellSchema | null;
    sources?: IExcelMappingCellSchema[];
}

interface IParams {
    organizationUuid: string;
    postData: IMappingData;
}

const createProFormaMapping = async ({ organizationUuid, postData }: IParams): Promise<IProFormaMapping> => {
    const response = await axiosInstance.post(API_ENDPOINTS.EXCEL_MAPPING(organizationUuid), postData);
    return response.data;
};

export const useCreateProFormaMapping = () => useMutation({
    mutationFn: createProFormaMapping,
});

export default useCreateProFormaMapping;
